import axios from '@/plugins/api.request'

/**
 * 列表
 * @param {*} params
 */
 export const classList = (params) => {
  return axios.request({
    method: 'get',
    url: 'edu.school/getClassList',
    params
  })
}

/**
 * 列表
 * @param {*} params
 */
 export const studentList = (params) => {
  return axios.request({
    method: 'get',
    url: 'edu.school/getStudentList',
    params
  })
}

/**
 * 添加班级
 * @param {*} params
 */
 export const addClass = (params) => {
  return axios.request({
    method: 'get',
    url: 'edu.school/addClass',
    params
  })
}

/**
 * 添加班级
 * @param {*} params
 */
 export const delClass = (params) => {
  return axios.request({
    method: 'get',
    url: 'edu.school/delClass',
    params
  })
}

/**
 * 添加学生
 * @param {*} data
 */
 export const addStudents = (data) => {
  return axios.request({
    method: 'post',
    url: 'edu.school/addStudents',
    data
  })
}


/**
 * 移除学生
 * @param {*} data
 */
 export const removeStudentsFromClass = (data) => {
  return axios.request({
    method: 'post',
    url: 'edu.school/removeStuFromClass',
    data
  })
}

/**
 * 学生重置密码
 * @param {*} params
 */
 export const studentResetPassword = (params) => {
  return axios.request({
    method: 'get',
    url: 'edu.school/studentResetPassword',
    params
  })
}

/**
 * 设置学生姓名
 * @param {*} params
 */
 export const setStudentName = (params) => {
  return axios.request({
    method: 'get',
    url: 'edu.school/setStudentName',
    params
  })
}

/**
 * 获取学生tree
 * @param {*} params
 */
 export const getStudentTree = (params) => {
  return axios.request({
    method: 'get',
    url: 'edu.school/getTreeClassAndStudent',
    params
  })
}

/**
 * 发送资源给学生
 * @param {*} data
 */
 export const sendResourceToStu = (data) => {
  return axios.request({
    method: 'post',
    url: 'edu.school/sendResourceToStudent',
    data
  })
}

/**
 * 获取学习情况
 * @param {*} params
 */
 export const getStudentStatusByClass = (params) => {
  return axios.request({
    method: 'get',
    url: 'edu.school/chapterStudyStatus',
    params
  })
}

/**
 * 教管获取教师列表
 * @param {*} params
 */
 export const getTeacherList = (params) => {
  return axios.request({
    method: 'get',
    url: 'edu.school/getTeacherList',
    params
  })
}

/**
 * 教管移除教师
 * @param {*} params
 */
 export const removeTeacher = (params) => {
  return axios.request({
    method: 'get',
    url: 'edu.school/removeTeacher',
    params
  })
}

/**
 * 首页统计
 * @param {*} params
 */
 export const homeStatistics = (params) => {
  return axios.request({
    method: 'get',
    url: 'edu.school/homeStatistics',
    params
  })
}

/**
 * 任务情况
 * @param {*} params
 */
 export const getStudentTaskList = (params) => {
  return axios.request({
    method: 'get',
    url: 'edu.school/studentTaskList',
    params
  })
}

/**
 * 任务详情
 * @param {*} params
 */
 export const getStudentTaskDetail = (params) => {
  return axios.request({
    method: 'get',
    url: 'edu.school/studentTaskDetail',
    params
  })
}

/**
 * 提交评分
 * @param {*} data
 */
 export const postTaskGrade = (data) => {
  return axios.request({
    method: 'post',
    url: 'edu.school/postTaskGrade',
    data
  })
}

/**
 * 获取班级学生学期报告列表
 * @param {*} params
 */
 export const getStudentReportList = (params) => {
  return axios.request({
    method: 'get',
    url: 'edu.school/getStudentReportList',
    params
  })
}

/**
 * 教师提交学生学期报告
 * @param {*} data
 */
 export const postStudentReport = (data) => {
  return axios.request({
    method: 'post',
    url: 'edu.school/postStudentReport',
    data
  })
}

/**
 * 教师删除学期报告
 * @param {*} params
 */
 export const delStudetnReport = (params) => {
  return axios.request({
    method: 'get',
    url: 'edu.school/delStudetnReport',
    params
  })
}


